const SHIPPING_STATE_KEY = "shippingState";
export {
  SHIPPING_STATE_KEY
};
//# sourceMappingURL=shippingTypes.js.map
